import { useCallback, useState } from 'react';

export const useEmailVerification = () => {
  const [error, setError] = useState<undefined | string>(undefined);

  const isValid = useCallback(
    (email: string) => {
      if (email === '') {
        setError('You must enter your email address first.');

        return false;
      }

      if (
        /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(
          email
        )
      ) {
        if (error) {
          setError(undefined);
        }

        return true;
      }

      setError('The email address you provided is not valid.');

      return false;
    },
    [error]
  );

  return { isValid, error };
};
